var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.613,
    height: 58.889,
    viewBox: "0 0 57.613 58.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(401.431 -393.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-372.6,393.73a29.085,29.085,0,0,1,28.518,25A28.724,28.724,0,0,1-367.4,450.861a28.642,28.642,0,0,1-16.205-1.645,2.283,2.283,0,0,0-1.333-.091c-4.186,1.093-8.36,2.23-12.54,3.348-2.539.68-4.306-1.094-3.631-3.64,1.022-3.856,2.061-7.709,3.053-11.574a2.032,2.032,0,0,0-.123-1.315,28.73,28.73,0,0,1,19.534-41.418C-376.665,394.1-374.617,393.987-372.6,393.73Zm-22.889,53.093c.4-.089.643-.133.885-.2,3.271-.879,6.544-1.752,9.81-2.649a2.568,2.568,0,0,1,1.887.151,23.764,23.764,0,0,0,15.027,1.856,23.96,23.96,0,0,0,18.932-26.651A23.877,23.877,0,0,0-376.6,399.121a23.8,23.8,0,0,0-16.948,34.943,4.123,4.123,0,0,1,.438,3.823,1.8,1.8,0,0,0-.071.223C-393.934,440.956-394.69,443.8-395.491,446.823Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-370.392,429.669h-4.889c-.148-2.434-.02-4.782,1.763-6.665.929-.981,1.985-1.843,2.99-2.751.445-.4.905-.787,1.364-1.173a3.487,3.487,0,0,0,1.342-3.82,3.889,3.889,0,0,0-3.174-2.8A5.331,5.331,0,0,0-377.7,416.4c-.068.222-.143.441-.237.732l-5-.622a7.945,7.945,0,0,1,2.2-5.193c2.491-2.711,5.7-3.4,9.2-3.176a10.279,10.279,0,0,1,6.967,2.945c2.973,3.015,3.069,6.979.16,10.05a32.432,32.432,0,0,1-3.39,3.125c-1.636,1.3-2.716,2.8-2.494,4.992a.871.871,0,0,1-.019.233A1.176,1.176,0,0,1-370.392,429.669Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-369.84,437.071h-5.427v-5.4h5.427Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.7224ac08601999b88bf0b8b7a788003d.svg";
export { ForwardRef as ReactComponent };